import AdminListing from './adminListing';

export default AdminListing;